import {Store, useStore} from "@tanstack/react-store";

export interface Diagram {
  title: string;
  code: string;
}

export interface DiagramState {
  diagrams: Record<string, Diagram>;
  addDiagram: (id: string, diagram: Diagram) => void;
  getDiagram: (id: string) => Diagram | undefined;
}

/**
 * TanStack Store instance for diagram state.
 * Created at module level — stable instance across renders.
 */
const diagramStore: Store<DiagramState> = new Store<DiagramState>({
  diagrams: {},

  addDiagram: (id: string, diagram: Diagram) => {
    diagramStore.setState((state: DiagramState) => ({
      ...state,
      diagrams: {
        ...state.diagrams,
        [id]: diagram,
      },
    }));
  },

  getDiagram: (id: string): Diagram | undefined => {
    return diagramStore.state.diagrams[id];
  },
});

/**
 * React hook to access diagram state with fine-grained subscriptions.
 * Only re-renders when the selected state slice changes.
 */
export function useDiagramStore<T>(selector: (state: DiagramState) => T): T {
  return useStore(diagramStore, selector);
}

// Export the raw store for non-react contexts if needed
export {diagramStore};
